
export const atLocationSaver = function() {

  const init = function () {
    if (navigator.geolocation) 
    {
      getCurrentLocation();
    }
  }

  const getCurrentLocation = function() {
    navigator.geolocation.getCurrentPosition(saveCurrentLocation);
  }

  const saveCurrentLocation = function(position) {
    Cookies.set('user_coords', {lat: position.coords.latitude, lng: position.coords.longitude});
  }
  init();
}